import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || "https://capimusic.synoweberp.in",
  // baseURL: process.env.REACT_APP_API_BASE || "http://192.168.1.86:5000",
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // admin JWT
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const startStream = () => API.post("/api/admin/stream/start");
export const pauseStream = () => API.post("/api/admin/stream/pause");
export const resumeStream = () => API.post("/api/admin/stream/resume");
export const skipTrack = () => API.post("/api/admin/stream/skip");
export const getStatus = () => API.get("/api/admin/stream/status");
export const getPlaybackMode = () =>
  API.get("/api/admin/playback/mode");

export const setPlaybackMode = (mode) =>
  API.post("/api/admin/playback/mode", { mode });
